export default Object.freeze({
    AUTHOR: "author",
    CORRESPONDING: "corresponding",
    CURATOR: "curator"
});
